<template>
  <div id="app">
    <HeadComponent v-if="!$route.meta.hideNav" />
    <router-view />
    <FootComponent v-if="!$route.meta.hideFooter"/>
  </div>
</template>

<script>
import HeadComponent from '@/components/HeadComponent.vue'
import FootComponent from '@/components/FootComponent.vue'
export default {
  name: 'App',
  components: {
    HeadComponent,
    FootComponent
  }
}
</script>

<style>
</style>
